import NewsFormPage from "./NewsFormPage"

const NewsCreate = () => {
  return (
    <NewsFormPage></NewsFormPage>
  )
}

export default NewsCreate